/* eslint-disable import/no-unresolved */
const constants = require('onestic-base/constants');
const utils = require('onestic-base/utils');

const runSlick = (element) => {
    const { prev, next } = utils.getSliderLabels();
    const slickItemsCountDesktop = parseInt($('#slickCount').val(), 10).toFixed(0);
    $(element).slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
        prevArrow: `<button type="button" class="icon-left-arrow-line prev no-btn" aria-label="${prev}"></button>`,
        nextArrow: `<button type="button" class="icon-right-arrow-line next no-btn" aria-label="${next}"></button>`,
        mobileFirst: true,
        infinite: true,
        responsive: [
            {
                breakpoint: constants.viewport_bootstrap.md,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: constants.viewport_bootstrap.lg,
                settings: {
                    slidesToShow: slickItemsCountDesktop,
                    slidesToScroll: 1,
                },
            },
        ],
    });
};

// eslint-disable-next-line consistent-return
const checkElement = (selector, fn) => {
    if ($(selector).length) {
        fn();
        return;
    }
    setTimeout(() => {
        checkElement(selector, fn);
    }, 100);
};

const slickConfig = () => {
    const containersMobileSlider = $('.blog-carousel');
    if (containersMobileSlider.length) {
        checkElement('.blog-carousel', runSlick.bind(null, '.blog-carousel'));
    }
};

export default () => {
    slickConfig();
};
